import { render, staticRenderFns } from "./TransHistory.vue?vue&type=template&id=3b8ce6d3&"
import script from "./TransHistory.vue?vue&type=script&lang=js&"
export * from "./TransHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports